import { Group, SimpleGrid, Stack, Text } from "@mantine/core";
import {
  IconCircleCheck,
  IconHourglassHigh,
  IconCircleX,
  IconWallet,
} from "@tabler/icons-react";
import classes from "./PaymentStats.module.css";

const KPI_CARDS = [
  { key: "success", label: "SUCCESSFUL", color: "#16A34A", bg: "#ECFDF3", Icon: IconCircleCheck },
  { key: "pending", label: "PENDING", color: "#F97316", bg: "#FFF4E8", Icon: IconHourglassHigh },
  { key: "failed", label: "FAILED", color: "#DC2626", bg: "#FEF2F2", Icon: IconCircleX },
  { key: "total", label: "TOTAL PAYMENTS", color: "#2563EB", bg: "#EFF6FF", Icon: IconWallet },
];

const PaymentStats = ({ stats, loading }) => {
  return (
    <Stack gap="md" mb="sm">
      <SimpleGrid cols={{ base: 1, xs: 2, lg: 4 }} spacing="md">
        {KPI_CARDS.map(({ key, label, color, bg, Icon }) => (
          <div key={key} className={classes.card}>
            <Group justify="space-between" align="flex-start" wrap="nowrap">
              <div>
                <Text className={classes.value} style={{ color }}>
                  {loading ? "—" : (stats?.[key] ?? 0).toLocaleString("en-IN")}
                </Text>
                <Text className={classes.label}>{label}</Text>
              </div>
              <div className={classes.iconWrap} style={{ background: bg, color }}>
                <Icon size={22} stroke={1.8} />
              </div>
            </Group>
          </div>
        ))}
      </SimpleGrid>
    </Stack>
  );
};

export default PaymentStats;
